import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map, tap, retry } from 'rxjs/operators';

import {ErrorService, EventService} from '..';
import { ConfigService } from './config.service';
import { PlayerOverTimeStatisticsResponse } from '../models/statistics';


@Injectable({ providedIn: 'root' })
export class StatisticsService {
    private statisticsURL = ConfigService.getApiEndpoint() + 'v1/statistics/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    getPlayerOverTime(id: string, query: any): Observable<PlayerOverTimeStatisticsResponse[]> {

        return this.http.get<PlayerOverTimeStatisticsResponse[]>(this.statisticsURL + 'playersOverTime/' + id, { params: query }).pipe(
            catchError(this.error.handleError('StatisticsService.getPlayerOverTime', null))
        );
    }

    getAccusationOverTime(id: string, query: any): Observable<PlayerOverTimeStatisticsResponse[]> {
        return this.http.get<PlayerOverTimeStatisticsResponse[]>(this.statisticsURL + 'accusationOverTime/' + id, { params: query }).pipe(
            catchError(this.error.handleError('StatisticsService.getAccusationOverTime', null))
        );
    }


}
